<template>
    <div class="blog-edit-wrapper">
        <div class="row">
            <div class="col-lg-2"></div>
            <div class="col-lg-8">
                <div class="card  blog-edit-wrapper" >
                    <div class="card-body">
                        <!-- Form -->
                        <form action="javascript:;" class="mt-2" v-on:submit.prevent="publishVideo">
                            <div class="row">
                                <div class="col-md-4 col-12">
                                  <div class="form-group mb-2">
                                    <label for="blog-edit-title">Title</label>
                                    <b-form-input
                                      id="blog-edit-title"
                                      v-model="videoTitle"
                                      v-on:keyup="slugCreate"
                                      placeholder="Video Title"
                                    />
                                  </div>
                                </div>

                                <div class="col-md-4 col-12">
                                    <div class="form-group mb-2">
                                        <label for="blog-edit-status">Category</label>
                                        <v-select
                                          id="video-edit-input"
                                          class="v-custom-style"
                                          :height="28"
                                          v-model="videoCategories"
                                          :options="VideoCategoryOption"
                                        />
                                    </div>

                                </div>
                                <div class="col-md-4 col-12">
                                    <div class="form-group mb-2">
                                      <label for="video-edit-input">Video Type</label>
                                      <v-select
                                        id="video-edit-input"
                                        class="v-custom-style"
                                        :height="28"
                                        v-model="videoType"
                                        :options="videoTypes"
                                      />
                                    </div>
                                </div>

                                <div class="form-group mb-2 col-lg-2 col-sm-12">
                                    <label for="blog-edit-status">Video Publish Status</label>
                                    <v-select
                                        id="video-edit-input"
                                        class="v-custom-style"
                                        :height="28"
                                        v-model="status"
                                        :options="statusOption"
                                    />
                                </div>
                                <div class="col-3" v-if="videoType == 'Youtube'">
                                    <div class="form-group mb-2">
                                        <label>YouTube Video Id</label>
                                        <div id="blog-editor-wrapper">
                                            <input
                                            id="textarea-state"
                                            v-model="videoUrl"
                                            class="form-control"
                                            placeholder="Paste  YouTube Id 'QpsYRVkWt_4'"
                                            />
                                        </div>
                                    </div>
                                </div>
                                <div class="col-7">
                                    <div class="form-group mb-2">
                                        <label>Video Description</label>
                                        <div id="blog-editor-wrapper">
                                            <b-form-textarea
                                            id="textarea-state"
                                            v-model="videoDecription"
                                            placeholder="Enter at least 10 characters"
                                            rows="1"
                                            ></b-form-textarea>
                                        </div>
                                    </div>
                                </div>
                                <div class="form-group mb-2 col-lg-12 col-sm-12">
                                    <label for="video-edit-input">Tags</label>
                                    <v-select
                                    id="video-edit-input"
                                    class="v-custom-style"
                                    :height="28"
                                    v-model="videoTag"
                                    multiple
                                    :options="videoTags"
                                    />
                                </div>
                                <div class="col-lg-12 mb-2" v-if="videoType == 'Custom Video'">
                                    <div class="border rounded p-2">
                                        <h4 class="mb-1">Featured Video</h4>
                                        <div class="media flex-column flex-md-row">
                                            <img src="/assets/images/slider/03.jpg" id="blog-feature-image preview" class="rounded mr-2 mb-1 mb-md-0" width="170" height="110" alt="Blog Featured Image"/>

                                            <div class="media-body">
                                                <small class="text-muted">Please upload a video.</small>
                                                <p class="my-50">
                                                    <a href="javascript:void(0);" id="blog-image-text">{{videoFileName}}</a>
                                                </p>
                                                <div class="d-inline-block">
                                                    <div class="form-group mb-0">
                                                        <div class="custom-file">
                                                            <input type="file" class="custom-file-input" id="blogCustomFile" accept="video/*" @change="handleChooseFile( $event )"/>
                                                            <label class="custom-file-label" for="blogCustomFile">Choose file</label>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="d-flex">
                                                    <div class="progress mt-1" style="width:70%;" v-if="percentCompleted > 0  && percentCompleted < 100">
                                                        <div class="progress-bar" :style="`width:${percentCompleted}%`">
                                                        </div>
                                                    </div>
                                                    <div v-if="percentCompleted > 0 && percentCompleted < 100 " style="margin:9px">
                                                        {{percentCompleted}}%
                                                    </div>
                                                    <div v-else-if="percentCompleted == 100" class="mt-2 text-primary">
                                                        <!-- todo handle draft and publish message -->
                                                        <div v-if="uploadCompleted == true">
                                                            Video uploaded successfully
                                                        </div>
                                                        <div v-else>
                                                            Processing video...
                                                        </div>

                                                    </div>

                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div class="col-lg-12 mb-2">
                                    <div class="border rounded p-2">
                                        <h4 class="mb-1">Video Thumbnail</h4>
                                        <div class="media flex-column flex-md-row">
                                            <img :src="file" id="blog-feature-image preview" class="rounded mr-2 mb-1 mb-md-0" width="170" height="110" alt="Blog Featured Image" v-if="file"/>
                                            <img src="/assets/images/slider/03.jpg" id="blog-feature-image preview" class="rounded mr-2 mb-1 mb-md-0" width="170" height="110" alt="Blog Featured Image" v-else/>

                                            <div class="media-body">
                                                <small class="text-muted">Required image resolution 800x400, image size 10mb.</small>
                                                <p class="my-50">
                                                    <a href="javascript:void(0);" id="blog-image-text">C:\fakepath\banner.jpg</a>
                                                </p>
                                                <div class="d-inline-block">
                                                    <div class="form-group mb-0">
                                                        <div class="custom-file">
                                                            <input type="file" class="custom-file-input" id="blogCustomFile" accept="image/*" data-toggle="modal" data-target="#larger" @change="selectedImg" enctype="multipart/form-data"/>
                                                            <label class="custom-file-label" for="blogCustomFile">Choose file</label>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-lg-12 mb-2">
                                      <span  class="text-danger">{{ uploadErrors}} <br></span>
                                </div>
                                <div class="col-12 mt-50">


                                    <button type="btn" disabled class="btn btn-primary mr-1" v-if="uploadCompleted == true">Publishing video...</button>
                                    <button type="submit" class="btn btn-primary mr-1" v-else>Publish Video</button>
                                </div>
                            </div>
                        </form>
                        <!--/ Form -->
                    </div>
                </div>
            </div>
            <div class="col-lg-2"></div>

        </div>
    </div>
    <div class="modal fade text-left show" id="larger" tabindex="-1" aria-labelledby="myModalLabel17" style="padding-right: 15px;" aria-modal="true" role="dialog">
        <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">×</span>
                    </button>
                </div>
                <div class="modal-body">
                    <cropper
                      v-if='img'
                      class="cropper"
                      :src="img"
                      :stencil-props="{
                        aspectRatio: 4/2
                      }"
                      @change="change"
                    />
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-primary waves-effect waves-float waves-light" data-dismiss="modal">Accept</button>
                </div>
            </div>
        </div>
    </div>
    <!-- <CreditFixrrLoader styleType="full" :toggle="PageisLoading"/> -->
</template>
<script>
import { ref } from 'vue'
import vSelect from 'vue-select'
import {BFormInput,BFormTextarea} from 'bootstrap-vue-3'
import { Cropper } from 'vue-advanced-cropper'
import 'vue-advanced-cropper/dist/style.css';
import 'vue-select/dist/vue-select.css';
import axios from 'axios';


export default {
    name:'CreateKnowledgeBaseVideos',
    components: {
        vSelect,BFormInput,Cropper
    },
    setup(){
        const editorContentRef=ref(null),
        uploadErrors = ref(null),
        videoTypes = ref(['Youtube','Custom Video']),
        videoType = ref('Youtube'),
        videoTitle = ref(null),
        videoTag = ref('Getting started'),
        videoTags = ref(['Getting started','credit scores','Fix','improve','letters','disputes']),
        slugCreate = ref(null),
        videoCategories = ref(null),
        status = ref('Draft'),
        statusOption = ref(['Publish','Draft']),
        VideoCategoryOption = ref([]),
        videoDecription=ref(null),
        file = ref(null),
        videoFile = ref(null),
        img = ref(null),
        videoUrl=ref(null),
        videoSrc = ref(null),
        videoFileName = ref('video.mp4'),
        percentCompleted=ref(0),
        uploadCompleted = ref();
        return {
            editorContentRef,
            uploadErrors,
            videoTypes,
            videoTitle,
            slugCreate,
            videoCategories,
            status,
            statusOption,
            VideoCategoryOption,
            videoDecription,
            file,
            videoFile,
            img,
            videoUrl,
            videoType,
            videoTags,
            videoTag,
            videoSrc,
            percentCompleted,
            videoFileName,
            uploadCompleted
        }
    },
    mounted() {
        this.getAllCategory()
    },
    methods:{
        selectedImg(e) {
            e.preventDefault()
            const file = e.target.files[0];
            this.img = URL.createObjectURL(file);
        },
        converter(canvas){
            this.file = canvas.toDataURL();
        },
        change({ coordinates, canvas }) {
            this.converter(canvas)
        },
        publishVideo(){
            let videoTitle = this.videoTitle,
            videoCategories = this.videoCategories,
            videoType = this.videoType,
            videoTag = this.videoTag,
            status = this.status,
            videoUrl = this.videoUrl,
            videoDecription = this.videoDecription,
            formData = new FormData();

            let $this = this;
            if(this.notEmpty(videoTitle) && this.notEmpty(videoCategories) && this.notEmpty(videoType) && this.notEmpty(status)  && this.notEmpty(videoDecription) && videoTag.length > 0){
                if(videoType == 'Youtube' && this.notEmpty(videoUrl) && this.notEmpty(this.file)){
                    let param = {
                        video_title: videoTitle,
                        video_categories : videoCategories,
                        video_type: videoType,
                        video_tag : videoTag,
                        status : status,
                        video_url : videoUrl,
                        video_decription : videoDecription,
                        image:this.file
                    }
                    this.sendRequest('/admin/knowledge/create/video',param);
                }else if(videoType == 'Custom Video' && this.videoFile){

                    formData.append('video_title',videoTitle);
                    formData.append('video_categories',videoCategories);
                    formData.append('video_type',videoType);
                    formData.append('video_tag',videoTag);
                    formData.append('status',status);
                    formData.append('video_file',this.videoFile);
                    formData.append('image',this.file);
                    formData.append('video_decription',videoDecription);
                    let config = {
                        onUploadProgress: (progressEvent)=> {
                            this.percentCompleted = Math.round( (progressEvent.loaded * 100) / progressEvent.total );
                        },
                        headers:{
                          "Content-Type":"multipart/form-data"
                        }
                    }
                    axios.post('/admin/knowledge/create/video',formData,config).then(({data})=>{
                        if(data.data.success){
                            $this.uploadCompleted = true;
                            toastr.success(data.data.message,'Upload Success');
                            setTimeout(()=>{
                                window.location.reload();
                            },3000)
                        }else{
                            $this.uploadCompleted = false;
                            toastr.success('Something went wrong please check if all fields are not empty.','Error')
                        }
                    }).catch((error)=>{
                        $this.uploadCompleted = false
                        $this.uploadErrors = error.response.data;
                    });
                }else{
                    $this.uploadErrors = 'All fields are required!';
                    $this.uploadCompleted = false
                    return true;
                }
            }
        },
        clearFields(){
            this.videoTitle = '';
            this.videoCategories = '';
            this.videoType = '';
            this.videoTag = 'Getting started';
            this.status = '';
            this.videoUrl = '';
            this.videoDecription = '';
            this.videoFile = '';
            this.videoFileName = 'video.mp4';
            this.file=null;
        },
        sendRequest(url,params,callback=null){
            let $this = this;
            this.uploadCompleted = true
            axios.post(url,params).then(({data})=>{
                if(data.data.success){
                    $this.uploadCompleted = false
                    toastr.success(data.data.message,'Success');
                    setTimeout(()=>{
                        window.location.reload();
                    },3000)
                }else{
                    $this.uploadCompleted = false
                    toastr.error(data.message,'Error');
                }
            }).catch((error)=>{
                $this.uploadCompleted = false
                $this.uploadErrors = error.response.data;
            });
        },
        notEmpty(value){
            if(value != "" || value != null){
                return true;
            }else{
                return false;
            }
        },
        getAllCategory(){
            let $this=this;
            axios.post('/admin/knowledge/req/all/categories').then(({data})=>{
                data.data.forEach(items=>{
                    $this.VideoCategoryOption.unshift(items.title)
                })
                $this.videoCategories = data.data[0].title
            }).catch()
        },
        handleChooseFile(event){
            this.videoFile = event.target.files[0];
            this.videoFileName = this.videoFile.name;
        },
    }
}
</script>
<style>
#video-edit-input{
    background: white;
}
#video-edit-input input{
    height:28px;
    background:white;
}
</style>
